import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {  SubmitJobPosting } from '@features/jobPostings';
import { errorMessage } from '@features/positions';
import axiosInstance from '@server/axiosInstance';
import { templateList } from '../constants';
import { tampleteJobUpdateRoute } from '../api/constants';

type useUpdateTemplateJobPostingProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateTemplateJobPosting = ({
  setErrorText = () => { },
}: useUpdateTemplateJobPostingProps) => {
  const client = useQueryClient();

  const { mutate: updateJobPosting, isLoading: isUpdatingJobPosting } =
    useMutation({
      mutationFn: (variables: SubmitJobPosting) =>
        axiosInstance
          .post(tampleteJobUpdateRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status === 200) {
          setErrorText('');
          client.invalidateQueries([templateList]);
        } else {
          setErrorText(data?.message ?? errorMessage);
        }
      },
      onError: () => setErrorText(errorMessage),
    });

  return { updateJobPosting, isUpdatingJobPosting };
};
